import React from 'react';

import { ObjectsWithInfo } from '../../model/tasks/types';
import { FileAttribute } from '../FileAttribute';
import { LinkAttribute } from '../LinkAttribute';
import { TextAttribute } from '../TextAttribute';
import styles from './TableAttribute.module.css';

type Props = {
  attribute: ObjectsWithInfo[];
};

type TableData = Record<'thead' | 'tbody', ObjectsWithInfo[]>;

export const TableAttribute: React.FC<Props> = ({ attribute }) => {
  const data = React.useMemo(() => {
    const data: TableData = {
      thead: [],
      tbody: [],
    };
    attribute.forEach((value) => {
      if (value.typeField === 'header') {
        data.thead.push(value);
      }
      if (value.typeField === 'content') {
        data.tbody.push(value);
      }
    });

    return data;
  }, [attribute]);

  return (
    <div className={styles.root} data-id="tableAttr">
      <table className={styles.tbl}>
        <thead>
          {data.thead.map((item) => (
            <tr key={item.idField}>
              {item.colField.map((col) => (
                <th className={styles.th} key={`td-${col.idField}`}>
                  {col.textField?.map((text, i) => <div key={i}>{text}</div>)}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {data.tbody.map((tr) => (
            <tr key={tr.idField}>
              {tr.colField.map((col) => (
                <td className={styles.td} key={`td-${col.idField}`}>
                  {typeof col.linkField === 'string' ? (
                    <a href={col.linkField} target="_blank" rel="noreferrer">
                      {col.linkField}
                    </a>
                  ) : (
                    <LinkAttribute attribute={col.linkField} />
                  )}
                  <FileAttribute attribute={col.fileField?.textField} />
                  <TextAttribute attribute={col.textField} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
